import styled, { keyframes } from "styled-components";

export const AppShell = styled.div`
    min-height: 100vh;
    color: #fbfcff;
    font-family:
        "Barlow",
        system-ui,
        -apple-system,
        "Segoe UI",
        Roboto,
        "Helvetica Neue",
        Arial;
    display: flex;
    padding: 15px 0px;
    box-sizing: border-box;
`;

/* Sidebar */
export const SidebarContainer = styled.aside`
    width: 280px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-sizing: border-box;
    position: relative;
    z-index: 4;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 20px;
`;

export const SidebarScroll = styled.div`
    margin-top: 6px;
    overflow-y: auto;
    padding-right: 6px;
    scrollbar-width: thin;
    height: 100%;
`;

/* Main content area */
export const ContentArea = styled.main`
    flex: 1;
    margin-left: 36px;
    position: relative;
    padding-top: 8px;
`;

/* Headings / text */
export const SidebarTitle = styled.div`
    font-weight: 700;
    color: #cdb5ff;
    font-size: 18px;
    letter-spacing: 0.4px;
    margin-bottom: 10px;
`;

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
`;

export const SectionHeaderTitle = styled.h2`
    font-size: 28px;
    margin: 0;
    color: #fff;
    font-weight: 800;
`;

export const ThinHr = styled.hr`
    border: none;
    height: 1px;
    background: rgba(255, 255, 255, 0.06);
    margin: 12px 0;
    border-radius: 2px;
`;

export const CardsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: 12px;
    width: 100%;
    margin-top: 20px;
    box-sizing: border-box;
`;

export const Card = styled.div`
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02));
    border-radius: 10px;
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(6px);
    cursor: pointer;
    transition:
        transform 200ms ease,
        box-shadow 200ms ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    min-height: 100px;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 6px 20px rgba(32, 12, 50, 0.4);
    }
`;

export const CardImage = styled.img`
    width: 100%;
    height: 80px;
    object-fit: cover;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
`;

export const CardLabel = styled.div`
    font-size: 13px;
    color: #fff;
    text-align: center;
    margin-bottom: 15px;
    margin-top: 5px;
    font-weight: 500;
`;

export const SidebarOption = styled.div`
    padding: ${(props) => (props.isLabel ? "7px 12px" : "5px 5px")};
    margin-left: 5px;
    border-radius: ${(props) => (props.selected ? "72px" : "10px")};
    color: ${(props) => (props.selected ? "#9D75F5" : "rgba(255,255,255,0.9)")};
    background: ${(props) => (props.selected ? "rgba(0, 0, 0, 0.4)" : "transparent")};
    font-weight: ${(props) => (props.selected ? 700 : 400)};
    cursor: pointer;
    font-size: 14px;
    transition: background 180ms ease;
`;

/* small helper text */
export const Small = styled.div`
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
`;

/* animation for content switching */
const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const AnimatedPanel = styled.div`
    animation: ${fadeUp} 300ms ease both;
    background: linear-gradient(180deg, rgba(24, 16, 42, 0.24), rgba(20, 11, 32, 0.18));
    border-radius: 14px;
    padding: 22px;
    border: 1px solid rgba(255, 255, 255, 0.04);
    box-sizing: border-box;
`;

export const SectionTitle = styled.h3`
    margin: 0 0 6px 0;
    font-size: 25px;
    color: #fff;
    font-weight: 800;
`;

export const SectionDescription = styled.div`
    color: rgba(255, 255, 255, 0.6);
    font-size: 13px;
    margin-bottom: 12px;
`;

export const HeadPanel = styled.div`
    padding: 0px 20px;
    font-size: 24px;
`;

export const HeadTitle = styled.h1`
    font-size: 28px;
`;
